export function getPropValue(prop, breakpoint) {
	if (typeof prop === "string") {
		return prop;
	} else {
		if (breakpoint) {
			return prop[breakpoint] ? prop[breakpoint] : prop.base;
		} else {
			return prop.base;
		}
	}
}
